module.exports = __webpack_public_path__ + "static/media/logo.aed13c04.aed13c04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.aed13c04.svg
// module id = 1078
// module chunks = 0